(function() {
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2) + ' USD';
  }

  function refreshCartDrawer() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart }, bubbles: true }));
        
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents({ detail: { cart } });
        }
      });
  }

  function loadComplementaryProducts() {
    const container = document.getElementById('cart-complementary-products');
    if (!container) return;

    const productId = container.dataset.productId;
    if (!productId || container.dataset.loaded === 'true') return;

    container.dataset.loaded = 'true';

    fetch(`/recommendations/products.json?product_id=${productId}&intent=complementary&limit=4`)
      .then(r => r.json())
      .then(data => {
        if (!data.products || data.products.length === 0) return;

        container.innerHTML = '';
        const list = document.createElement('div');
        list.className = 'complementary-products__product-list';

        data.products.forEach(product => {
          const item = document.createElement('div');
          item.className = 'complementary-products__product';
          item.style.cssText = 'display:flex !important; flex-direction:row !important; align-items:flex-start; gap:12px; padding-bottom:16px; border-bottom:1px solid #e8e8e8;';

          const sizeOption = product.options.find(o =>
            o.name.toLowerCase() === 'size' || o.name.toLowerCase() === 'talla'
          );

          let variantSelectorHTML = '';
          if (sizeOption && product.variants.length > 1) {
            const optionIndex = product.options.indexOf(sizeOption);
            variantSelectorHTML = `
              <select class="complementary-size-select" style="font-family:'Inter', sans-serif; font-size:13px; font-weight:500; border:1px solid #c9c9c9; padding:6px 24px 6px 8px; background-color:#fff; cursor:pointer; appearance:none; -webkit-appearance:none; background-image:url('data:image/svg+xml,%3Csvg xmlns=\\'http://www.w3.org/2000/svg\\' width=\\'10\\' height=\\'6\\'%3E%3Cpath d=\\'M0 0l5 6 5-6z\\' fill=\\'%23000\\'/%3E%3C/svg%3E'); background-repeat:no-repeat; background-position:right 8px center; min-width:100px;">
                <option value="">Select size</option>
                ${product.variants.map(v => {
                  const sizeValue = v.options[optionIndex];
                  return `<option value="${v.id}" ${!v.available ? 'disabled' : ''}>${sizeValue}${!v.available ? ' – Sold out' : ''}</option>`;
                }).join('')}
              </select>
            `;
          } else if (product.variants.length === 1) {
            variantSelectorHTML = `<input type="hidden" class="complementary-size-select" value="${product.variants[0].id}">`;
          }

          item.innerHTML = `
            <a href="${product.url}" style="flex-shrink:0;">
              <img src="${product.featured_image}" alt="${product.title}" width="80" height="100" style="display:block; object-fit:cover;">
            </a>
            <div class="complementary-product__info" style="display:flex; flex-direction:column; flex:1; min-width:0; gap:6px;">
              <a href="${product.url}" style="text-decoration:none; color:inherit;">
                <span class="complementary-product__title" style="font-family:'Inter', sans-serif; font-size:11px; font-weight:700; letter-spacing:0.03em; text-transform:uppercase; display:block; color:#212121;">${product.title}</span>
              </a>
              <span class="complementary-product__price" style="font-family:'Inter', sans-serif; font-size:11px; font-weight:700; color:#6b6b6b;">${formatMoney(product.price)}</span>
              <div class="complementary-product__actions" style="display:flex; flex-direction:row; align-items:center; gap:8px; margin-top:4px;">
                ${variantSelectorHTML}
                <button class="complementary-add-to-cart" style="font-family:'Inter', sans-serif; font-size:12px; font-weight:600; letter-spacing:0.06em; text-transform:uppercase; background-color:#333; color:#fff; border:1px solid #333; padding:8px 12px; cursor:pointer; white-space:nowrap; transition: all 0.2s ease;">Add to cart</button>
              </div>
              <span class="complementary-feedback" style="font-family:'Inter', sans-serif; font-size:12px; color:#333;"></span>
            </div>
          `;

          // Hover effect en el botón
          const btn = item.querySelector('.complementary-add-to-cart');
          btn.addEventListener('mouseenter', function() {
            this.style.backgroundColor = '#fff';
            this.style.color = '#333';
          });
          btn.addEventListener('mouseleave', function() {
            this.style.backgroundColor = '#333';
            this.style.color = '#fff';
          });

          list.appendChild(item);
        });

        container.appendChild(list);

        container.querySelectorAll('.complementary-add-to-cart').forEach(button => {
          button.addEventListener('click', function() {
            const productDiv = this.closest('.complementary-products__product');
            const select = productDiv.querySelector('.complementary-size-select');
            const feedback = productDiv.querySelector('.complementary-feedback');
            const variantId = select ? select.value : null;

            if (!variantId) {
              feedback.textContent = 'Please select a size.';
              return;
            }

            this.disabled = true;
            this.textContent = 'Adding...';
            feedback.textContent = '';

            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
            })
            .then(r => r.json())
            .then(result => {
              if (result.status) {
                feedback.textContent = result.description || 'Error.';
                this.disabled = false;
                this.textContent = 'Add to cart';
              } else {
                feedback.textContent = '✓ Added!';
                this.textContent = '✓ Added';
                refreshCartDrawer();
              }
            })
            .catch(() => {
              feedback.textContent = 'Something went wrong.';
              this.disabled = false;
              this.textContent = 'Add to cart';
            });
          });
        });
      });
  }

  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType !== 1) return;
        const container = node.id === 'cart-complementary-products'
          ? node
          : node.querySelector('#cart-complementary-products');
        if (container && container.dataset.productId) {
          loadComplementaryProducts();
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();